import { useState, useEffect } from "react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "@/context/TranslationContext";
import styles from "./Header.module.scss";

export default function Header() {
  const { t, language, setLanguage } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ""}`}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo} onClick={closeMenu}>
          &lt;Kori<span>Code</span>/&gt;
        </Link>

        <nav className={isMenuOpen ? styles.open : ""}>
          <ul>
            <li>
              <a href="#hero" className={styles.navLink} onClick={toggleMenu}>
                {t("NAV.HOME")}
              </a>
            </li>
            <li>
              <a href="#trust" className={styles.navLink} onClick={toggleMenu}>
                {t("NAV.ABOUT")}
              </a>
            </li>
            <li>
              <a href="#skills" className={styles.navLink} onClick={toggleMenu}>
                {t("NAV.SKILLS")}
              </a>
            </li>
            {/* <li>
              <a
                href="#projects"
                className={styles.navLink}
                onClick={toggleMenu}
              >
                {t("NAV.PROJECTS")}
              </a>
            </li> */}
            <li>
              <a
                href="#contact"
                className={styles.navLink}
                onClick={toggleMenu}
              >
                {t("NAV.CONTACT")}
              </a>
            </li>
            {/* Blog route is hidden but still accessible via direct URL */}
            <li className={styles.langSwitch}>
              <button
                onClick={() => setLanguage("de")}
                className={language === "de" ? styles.active : ""}
              >
                DE
              </button>
              <span>|</span>
              <button
                onClick={() => setLanguage("en")}
                className={language === "en" ? styles.active : ""}
              >
                EN
              </button>
            </li>
          </ul>
        </nav>

        <button
          className={styles.menuToggle}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <i className={`bx ${isMenuOpen ? "bx-x" : "bx-menu"}`}></i>
        </button>
      </div>
    </header>
  );
}
